import { QueryClient } from '@tanstack/react-query';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { getQueryClientContext } from 'data/core/sagas/query-client';
import { getTemplatesDetailsQueryKey } from 'queries';
import { TemplateObjectType } from '../api';
import { setConditionalVariablesInDocumentTemplate } from '../documents/slices';
import { setConditionalVariablesInProjectTemplate } from '../projects/slices';
import {
  setConditionalVariablesAction,
  SetConditionalVariablesActionPayload,
} from './actions';

function* setConditionalVariablesSaga(
  action: StoreActionProps<SetConditionalVariablesActionPayload>,
) {
  const {
    payload: { formValues, variableId, templateType, templateId },
  } = action;

  const queryClient = (yield getQueryClientContext()) as QueryClient;

  switch (templateType) {
    case TemplateObjectType.Project:
      yield put(
        setConditionalVariablesInProjectTemplate({
          variableId,
          formValues,
          templateType,
        }),
      );
      break;
    case TemplateObjectType.Document:
      yield put(
        setConditionalVariablesInDocumentTemplate({
          variableId,
          formValues,
          templateType,
          templateId,
        }),
      );
      break;
    case TemplateObjectType.StatusUpdates:
      if (templateId) {
        const _template = queryClient.getQueryData(
          getTemplatesDetailsQueryKey(templateId),
        );

        queryClient.setQueryData(
          getTemplatesDetailsQueryKey(templateId),
          (currentTemplate: any) => {
            return {
              ...currentTemplate,
              templateMeta: {
                ...(currentTemplate?.templateMeta ?? {}),
                conditionalVariables: {
                  ...(currentTemplate?.templateMeta?.conditionalVariables ??
                    {}),
                  [variableId]: {
                    formValues,
                  },
                },
              },
            };
          },
        );
      }

      break;
    default:
      break;
  }
}

export function* watchTemplateVariableSaga(): Generator {
  yield takeLatest(
    setConditionalVariablesAction.type,
    setConditionalVariablesSaga,
  );
}
